import { Page } from "@/components/Page";
import { Hero } from "@/components/home/Hero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { TwoServices } from "@/components/home/TwoServices";
import { HomeVisitBanner } from "@/components/home/HomeVisitBanner";
import { AboutSection } from "@/components/AboutSection";
import { SpecialistsSection } from "@/components/SpecialistsSection";
import { HomeVisit } from "@/components/home/HomeVisit";
import { ConditionsSection } from "@/components/ConditionsSection";
import { WhyChoose } from "@/components/WhyChoose";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { HoursSection } from "@/components/HoursSection";
import { AppointmentSection } from "@/components/AppointmentSection";

export default function Home() {
  return (
    <Page>
      <Hero />
      <BrandMarquee />
      <HomeVisitBanner />
      <TwoServices />
      <AboutSection />
      <SpecialistsSection />
      <HomeVisit />
      <ConditionsSection />
      <WhyChoose />
      <Gallery />
      <Reviews />
      <HoursSection />
      <AppointmentSection />
    </Page>
  );
}
